import React, { useState, useCallback } from 'react'
import { Modal as SemanticUiModal } from 'semantic-ui-react'
import hoistNonReactStatics from 'hoist-non-react-statics'

/**
 *
 * @param {boolean} [defaultIsOpen=false] The initial value of Modal's open status
 */
export default function useModal(defaultIsOpen = false) {
  const [isOpen, setIsOpen] = useState(defaultIsOpen)

  function open() {
    setIsOpen(true)
  }

  function close() {
    setIsOpen(false)
  }

  const Modal = useCallback(
    /**
     *
     * @param {import('semantic-ui-react').ModalProps} props
     */
    function Modal(props) {
      function handleClose(event, data) {
        props.onClose && props.onClose(event, data)
        close()
      }

      return <SemanticUiModal open={isOpen} {...props} onClose={handleClose} />
    },
    [isOpen]
  )
  const EnhancedModal = hoistNonReactStatics(Modal, SemanticUiModal)

  return {
    Modal: EnhancedModal,
    open,
    close,
    setOpen: setIsOpen,
    isOpen,
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/hooks/useModal/index.js